import {
  DatePickerUncontrolled,
  DateRangeSelect,
  ISelectType,
} from "@4uhub/lib4uhub";
import { Box, Stack, TextField } from "@mui/material";
import { Dispatch, memo, SetStateAction, useState } from "react";
import { useTranslation } from "react-i18next";

import FiltersActions from "../../../../components/FiltersActions/FiltersActions";
import useFilter from "../../../../hooks/useFilter";

interface IMacroFilterProps {
  onFilterParams: Dispatch<SetStateAction<IFilterParams>>;
  filterParams: IFilterParams;
}

export interface IFilterParams {
  Name: string;
  Cpf: string;
  TasyIdentifier: string;
  LastModifiedStart: Date | null;
  LastModifiedEnd: Date | null;
}

const translationPath = "page.4uBus.logs.syncPersons.";

const MacroFilter: React.FC<IMacroFilterProps> = ({
  onFilterParams,
  filterParams,
}) => {
  const { filter, showCleanBtn, initialState, setFilter, cleanFilter } =
    useFilter(filterParams);

  const { t } = useTranslation();

  const [period, setPeriod] = useState<ISelectType | null>(null);
  const [disableDates, setDisableDates] = useState<boolean>(true);

  const hasOnlyOneDate =
    Boolean(filter.LastModifiedStart) !== Boolean(filter.LastModifiedEnd);

  const filterHandler = () => {
    onFilterParams(filter);
  };

  const cleanHandler = () => {
    onFilterParams(initialState.current);
    cleanFilter();
    setPeriod(null);
    setDisableDates(true);
  };

  return (
    <Stack flexDirection={"row"} gap={2} alignItems="center">
      <TextField
        value={filter.Name}
        size="small"
        label={t(translationPath + "name")}
        fullWidth
        onChange={(event) => setFilter({ Name: event.target.value })}
      />

      <TextField
        value={filter.Cpf}
        size="small"
        label={t(translationPath + "cpf")}
        fullWidth
        onChange={(event) => setFilter({ Cpf: event.target.value })}
      />

      <TextField
        value={filter.TasyIdentifier}
        size="small"
        label={t(translationPath + "tasy_identifier")}
        fullWidth
        onChange={(event) => setFilter({ TasyIdentifier: event.target.value })}
      />

      <DateRangeSelect
        value={period}
        onValueSelected={setPeriod}
        setStartDate={(date) => setFilter({ LastModifiedStart: date })}
        setEndDate={(date) => setFilter({ LastModifiedEnd: date })}
        setEnableFields={setDisableDates}
      />

      <Box sx={{ flex: "0 0 160px" }}>
        <DatePickerUncontrolled
          value={filter.LastModifiedStart}
          onChange={(date) => setFilter({ LastModifiedStart: date })}
          label={t(translationPath + "start_date") || "Data Inicial"}
          isClearable={false}
          disable={disableDates}
        />
      </Box>

      <Box sx={{ flex: "0 0 160px" }}>
        <DatePickerUncontrolled
          value={filter.LastModifiedEnd}
          onChange={(date) => setFilter({ LastModifiedEnd: date })}
          label={t(translationPath + "end_date") || "Data Final"}
          isClearable={false}
          disable={disableDates}
        />
      </Box>

      <FiltersActions
        onFilter={filterHandler}
        onClean={cleanHandler}
        showCleanBtn={showCleanBtn}
        disableFilterBtn={hasOnlyOneDate}
      />
    </Stack>
  );
};

export default memo(MacroFilter);
